<template>
    <div class="payContent">
        <img src="../../../../assets/imgs/brandReview/putRecord/形状 2.png" alt="">
        <div class="substance">
            <div class="result">
                <h3>支付成功</h3>
                <p>您购买的是{{serveItem}}产品，请尽快复审材料，公司宝会为您初步审核，审核通过后提交商标局</p>
            </div>
            <div class="btn">
                <el-button @click="$router.push('/brandReview/brandController')">进入控制台</el-button>
                <el-button @click="$router.push('/brandReview/brandController/myOrder')">查看我的订单</el-button>
            </div>
            <div class="prompt">
                <p>您购买的是{{serveItem}}产品，顾问会在1个工作日内与您联系，请保持电话畅通。</p> 
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            serveItem:""
        }
    },
    mounted() {
        this.$store.commit('qffillmaterials/changeActivedIndex', 3);
    },
    created(){
        this.serveItem = this.$route.query.serveItem
    }
}
</script>
<style lang="scss" scoped>
.payContent{
    position: relative;
    margin: 0 auto;
    width: 80%;
    height: 370px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    img{
        position: absolute;
        top: 22%;
        left: 18%;
    }
    .substance{
        width: 50%;
        margin: 0 auto;
        .result{
            h3{
                font-size: 18px;
                font-weight: 900;
            }
            p{
                width: 424px;
                height: 39px;
                font-size: 12px;
                margin: 20px 0;
            }
        }
        .btn{
            .el-button{
            width: 112px;
            height: 30px;
            line-height: 7px;
            text-align: center;
            }
            .el-button:nth-child(1){
                background-color: #006DFF;
                color: #FFF;
                border:1px solid rgba(0,109,255,1);
                border-radius: 0px;
            }
            .el-button:nth-child(2){
                color:#006DFF;
                border: 0px;
            }
            .el-button:nth-child(2):hover{
                background-color: #FFF;
            }
        }
        .prompt{
            margin-top: 30px;
            p{
                font-size: 12px;
                margin-bottom: 10px;
                color: #999999;
            }
        }
    }
}
</style>